<template>
  <component :is="component" />
</template>

<script>
import EquityChangeHk from './EquityChangeHk.vue'
import EquityChangeUs from './EquityChangeUs.vue'
import EquityChangeHs from './EquityChangeHs.vue'

const components = {
  hk: EquityChangeHk,
  hs: EquityChangeHs,
  us: EquityChangeUs
}
export default {
  computed: {
    symbol() {
      return this.$route.query.symbol
    },
    market() {
      return this.$funs.getMarket(this.symbol)
    },
    component() {
      return components[this.market]
    }
  }
}
</script>

<style></style>
